export default class AbstractComponent {

    constructor(_el, options = {}) {
        Object.assign(this, {
            _el,
            _intersectionObserver: false,
            _options: {
                triggerIntersection: false,
                intersection: {
                    rootMargin: '0px 0px',
                    threshold: 0
                }
            },
            _flags : '',
            _id: '',
            _hash: ''
        });

        // Options merging
        this._options = { ...this._options, ...options };
        this._flags = this._el.dataset.componentFlags || '';
        this._id = this._el.dataset.componentId || null;
        this._hash = this._el.dataset.componentHash
            ? `#${this._el.dataset.componentHash}`
            : null;

        this._intersectionHandler = this._intersectionHandler.bind(this);

        if (this._options.triggerIntersection) {
            this._initIntsersection();
        }
    }

    /**
     * init - Initialization call
     *
     */
    _init() {
        const { hash } = window.location;
        if (this._hash && this._hash === hash) {
            this.onHashHandle();
        }
    }

    /**
     * resize - Resize event handler
     * @param {event} e - event
     *
     */
    resize(e) { }

    /**
     * destroy - Destroy the current instance
     *
     */
    destroy() {
        
    }

    onHashHandle() { }
    onHashEnter() {
        if (this._hash) {
            let href = window.location.href;
            const hash = window.location.hash;

            href = window.location.hash
                ? href.replace(hash, this._hash)
                : `${href}${this._hash}`

            window.history.replaceState(
                null,
                null,
                href
            );
        }
    }

    onHashLeave() {
        if (this._hash) {
            window.history.replaceState(
                null,
                null,
                window.location.href.split('#')[0]
            );
        }
    }

    /**
     * _initIntsersection - Initialize intersection observer on this component
     *
     */
    _initIntsersection() {
        this._intersectionObserver = new IntersectionObserver(
            this._intersectionHandler,
            this._options.intersection
        );
        this._intersectionObserver.observe(this._el);
    }

    /**
     * _intersectionHandler - Intersection observer handler
     * @param {IntersectionObserverEntry[]} entries - Intersection Observer Entries
     *
     */
    _intersectionHandler(entries) { }

    /**
     * _hasFlag - Check for flag presence
     * @param {string} name - name of the flag
     * @return {boolean} presence of the flag on the component
     *
     */
    _hasFlag(name) {
        return this._flags ? this._flags.indexOf(name) !== -1 : false;
    }

    get id() {
        return this._id;
    }
}